import { useState } from 'react';
import { useGetImage } from '@namespace/themes';
import { useBonusImageUrl } from '../../../../hooks/useBonusImageUrl';

import styles from '../../index.module.css';

const BonusImage = ({ bonus, oldImageUrl }) => {
  const { accentImageUrl: imageUrl } = useBonusImageUrl(bonus, oldImageUrl);
  const [isError, setIsError] = useState(false);
  const getImg = useGetImage();
  const placeholderImageSrc = `/images/bonuses/${getImg(
    'bonusPlaceholderLight',
    'bonusPlaceholderDark'
  )}.png`;

  return (
    <img
      src={isError ? placeholderImageSrc : imageUrl}
      onError={() => setIsError(true)}
      alt="bonusImage"
      data-testid="bonus-image"
      className={styles.image}
    />
  );
};

export default BonusImage;
